import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import GridUniDriver from './Grid.uni.driver';

export function GridFoldersSectionUniDriver(base: UniDriver, body: UniDriver) {
  const refreshLoader = () => base.$('[data-hook="refresh-loader"]');

  return {
    ...baseUniDriverFactory(base),
    /** Gets a [GridUniDriver]() for the section */
    grid: () => GridUniDriver(base, body),
    /** Indicates the section header exists */
    headerExists: () => base.$('[data-hook="section-header"]').exists(),
    /** Indicates a skeleton loader exists */
    refreshLoaderExists: () => refreshLoader().exists(),
  };
}
